module.exports = __webpack_public_path__ + "common/payment/icon-master-0b3a09b07a74b05de357db771b8f99d1.svg";